"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ProductCardCompact = void 0;
require("./ProductCardCompact.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ProductCard = _interopRequireDefault(require("../ProductCard/ProductCard"));
var _ProductCardFooter = _interopRequireDefault(require("../ProductCardFooter/ProductCardFooter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ProductCardCompact component
 *
 * @method
 * @param { ProductCardCompactProps} props
 * @returns ProductCardCompact
 */

const ProductCardCompact = props => {
  const {
    /* actions */
    externalActionElement,
    // the fully clickable link that goes to the PDP page
    fullyClickableParent,
    // boolean if card can be fully clickable
    externalFooterActionElement,
    // addToBagAction in web-site

    /* header */
    externalMediaElement,
    // image from web-site

    /* price */
    kitPrice,
    // kit price in web-site
    kitPriceAccessibilityLabel,
    // kit price accessibility in web-site
    listPrice,
    // list price in web-site
    listPriceAccessibilityLabel,
    // list price accessibility in web-site
    priceLabel,
    // price label in web-site
    salePrice,
    // sale price in web-site
    salePriceAccessibilityLabel,
    // sale price accessibility in web-site
    priceMessage,
    // message to display when there is no price
    priceDisabled,
    // sets the disabled state for the price

    /* reviews */
    rating,
    // rating number in web-site
    reviewAccessibilityLabel,
    // review accessibility in web-site
    reviewCount,
    // number of reviews in web-site

    /* text */
    additionalOffersText,
    // second valueTag in web-site
    badge,
    // top left badge text in web-site
    brandName,
    // brand name in web-site
    promoText,
    // first valueTag in web-site
    productName,
    // product name in web-site
    sponsoredBadgeLabel,
    // sponsored text in web-site
    variantLabel,
    // support text in web-site

    /* bookmark favorites */
    displayBookmark,
    externalBookmarkAction,
    // bookmarkAction in web-site

    /* tags */
    tagsTop,
    tagsBottom
  } = props;
  const screenReaderText = brandName + ' ' + productName;
  const showBookmark = displayBookmark && !!externalBookmarkAction;
  const showAddToBag = !!externalFooterActionElement;
  const componentClassName = (0, _classnames.default)('pal-c-ProductCardCompact', {});
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement(_ProductCard.default, {
    badge: badge,
    brandName: {
      text: screenReaderText,
      textStyle: 'body'
    },
    contentGap: "sm",
    contentPadding: "none",
    externalActionElement: externalActionElement,
    fullyClickableParent: fullyClickableParent,
    externalFooterActionElement: externalFooterActionElement,
    externalMediaElement: externalMediaElement,
    headerBackgroundColor: "background-xsubtle",
    headerPadding: "compact",
    hideFooter: true,
    imageAltText: screenReaderText,
    imgGap: "none",
    imgAlign: "top",
    price: {
      disabled: priceDisabled,
      kitPrice: kitPrice,
      kitPriceAccessibilityLabel: kitPriceAccessibilityLabel,
      listPrice: listPrice,
      listPriceAccessibilityLabel: listPriceAccessibilityLabel,
      message: priceMessage,
      priceLabel: priceLabel,
      salePrice: salePrice,
      salePriceAccessibilityLabel: salePriceAccessibilityLabel,
      variant: 'default'
    },
    ratings: {
      maxRating: 5,
      rating: rating,
      reviewAccessibilityLabel: reviewAccessibilityLabel,
      reviewsCount: reviewCount
    },
    screenReaderText: screenReaderText,
    secondValueTag: additionalOffersText,
    sponsoredBadgeLabel: sponsoredBadgeLabel,
    tagsBottom: tagsBottom,
    tagsTop: tagsTop,
    valueTag: promoText,
    variantLabel: variantLabel
  }), showAddToBag && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardFooter__addToBag"
  }, /*#__PURE__*/_react.default.createElement(_ProductCardFooter.default, {
    alignment: "left",
    externalFooterActionElement: externalFooterActionElement,
    sponsoredBadgeLabel: sponsoredBadgeLabel
  })), showBookmark && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardCompact__bookmark"
  }, externalBookmarkAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalBookmarkAction))));
};

/**
 * Property type definitions
 * @typedef ProductCardCompactProps
 * @type {object}
 * @property {object} actionGroups - product action (palette action)
 * @property {object} addToBagAction - addToBagAction (palette action)
 * @property {string} additionalOffersText - second valueTag text
 * @property {string} ariaLabelBookmark - ariaLabel for the bookmark
 * @property {string} badge - top left badge text
 * @property {object} bookmarkAction - action object for the bookmark (palette action)
 * @property {string} brandName - the brandName for the product card
 * @property {boolean} displayBookmark - This sets the flag to display bookmark
 * @property {object} externalActionElement - fully clickable card action from web-site
 * @property {object} externalFooterActionElement - addToBagAction coming from web-site
 * @property {object} externalBookmarkAction - bookmark action coming from web-site
 * @property {object} externalMediaElement - the image coming from web-site
 * @property {boolean} fullyClickableParent - boolean if card can be fully clickable
 * @property {string} kitPrice - kit price of the product
 * @property {string} kitPriceAccessibilityLabel - Sets the kit price accessibility label
 * @property {string} listPrice - list price of the product
 * @property {string} listPriceAccessibilityLabel - Sets the list price accessibility label
 * @property {boolean} priceDisabled - sets the disabled state for the price
 * @property {string} priceLabel - price label of the product
 * @property {string} priceMessage - message to display when there is no price
 * @property {string} productName - name of the product
 * @property {string} promoText - This is the promo text for the product
 * @property {number} rating - This is the rating of the product
 * @property {object} removeFavoriteAction - Sets the remove Favorite Action (palette action)
 * @property {string} reviewAccessibilityLabel - This is the reviewAccessibilityLabel for the product
 * @property {number} reviewCount - This is the reviewCount for the product
 * @property {string} salePrice - sale price of the product
 * @property {string} salePriceAccessibilityLabel - Sets the sale price accessibility label
 * @property {string} sponsoredBadgeLabel - sponsored text of the product card
 * @property {array} tagsBottom - Allows passing an array of tag objects to display in the card body
 * @property {array} tagsTop - Allows passing an array of tag objects to display in the card header
 * @property {string} variantLabel - support text of the product card
 */
exports.ProductCardCompact = ProductCardCompact;
const propTypes = exports.propTypes = {
  /**
   * product action (palette action)
   */
  actionGroups: _propTypes.default.object,
  /**
   * addToBagAction (palette action)
   */
  addToBagAction: _propTypes.default.object,
  /**
   * second valueTag text
   */
  additionalOffersText: _propTypes.default.string,
  /**
   * aria-label for the bookmark
   */
  ariaLabelBookmark: _propTypes.default.string,
  /**
   * top left badge text
   */
  badge: _propTypes.default.string,
  /**
   * action object for the bookmark (palette action)
   */
  bookmarkAction: _propTypes.default.object,
  /**
   * brandName for the product card
   */
  brandName: _propTypes.default.string,
  /**
   * sets the flag to display bookmark
   */
  displayBookmark: _propTypes.default.bool,
  /**
   * fully clickable card action from web-site
   */
  externalActionElement: _propTypes.default.object,
  /**
   * addToBagAction coming from web-site
   */
  externalFooterActionElement: _propTypes.default.object,
  /**
   * bookmark action coming from web-site
   */
  externalBookmarkAction: _propTypes.default.object,
  /**
   * the externalMediaElement for the ProductCardDefault
   */
  externalMediaElement: _propTypes.default.object,
  /**
   * boolean if card can be fully clickable
   */
  fullyClickableParent: _propTypes.default.bool,
  /**
   * kit price of the product
   */
  kitPrice: _propTypes.default.string,
  /**
   * Sets the kit price accessibility label
   */
  kitPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * list price of the product
   */
  listPrice: _propTypes.default.string,
  /**
   * Sets the list price accessibility label
   */
  listPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * Sets the disabled state of the price
   */
  priceDisabled: _propTypes.default.bool,
  /**
   * price label of the product
   */
  priceLabel: _propTypes.default.string,
  /**
   * Sets the message to display when there is no price
   */
  priceMessage: _propTypes.default.string,
  /**
   * productName for the product card
   */
  productName: _propTypes.default.string,
  /**
   * promo text for the product
   */
  promoText: _propTypes.default.string,
  /**
   * rating of the product
   */
  rating: _propTypes.default.number,
  /**
   * sets the remove Favorite Action (palette action)
   */
  removeFavoriteAction: _propTypes.default.object,
  /**
   * the reviewAccessibilityLabel for the product
   */
  reviewAccessibilityLabel: _propTypes.default.string,
  /**
   * the reviewCount for the product
   */
  reviewCount: _propTypes.default.number,
  /**
   * sale price of the product
   */
  salePrice: _propTypes.default.string,
  /**
   * Sets the sale price accessibility label
   */
  salePriceAccessibilityLabel: _propTypes.default.string,
  /**
   * sponsored text of the product card
   */
  sponsoredBadgeLabel: _propTypes.default.string,
  /**
   * Allows passing an array of tag objects to the ProductCardBody
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tagsBottom: _propTypes.default.arrayOf(_propTypes.default.object),
  /**
   * Allows passing an array of tag objects to the ProductCardHeader
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tagsTop: _propTypes.default.arrayOf(_propTypes.default.object),
  /**
   * support text of the product card
   */
  variantLabel: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} displayBookmark=false - This sets the flag to display bookmark
 */
const defaultProps = exports.defaultProps = {
  displayBookmark: false
};
ProductCardCompact.propTypes = propTypes;
ProductCardCompact.defaultProps = defaultProps;
var _default = exports.default = ProductCardCompact;